module.exports = __webpack_public_path__ + "b487e29857badb7e5cad8bf0a7f56e2f.pdf";